export class IxTreeTestIds {
  public static CHEVRON_TOGGLE = (id: string) => `ix-tree-chevron-${id}`;

  public static CHECKBOX = (id: string) => `ix-tree-checkbox-${id}`;

  public static ICON = (id: string) => `ix-tree-icon-${id}`;

  public static LABEL = (id: string) => `ix-tree-label-${id}`;

  public static NODE = (id: string) => `ix-tree-node-${id}`;

  public static CONTAINER = (id: string) => `ix-tree-container-${id}`;
}
